import { useIntl, defineMessages } from 'react-intl';
import { TabPane } from 'semantic-ui-react';
import DoveDormireTabContent from './DoveDormireTabContent';
import EsperienzeTabContent from './EsperienzeTabContent';
import MyFeCardTabContent from './MyFeCardTabContent';

const Tabs = (props) => {
  const intl = useIntl();
  return [
    {
      menuItem: {
        key: 'tab1',
        icon: 'bed',
        content: intl.formatMessage(messages.prenotazioni_dove_dormire),
        className: props.tabColor1,
      },
      render: () => (
        <TabPane attached={false}>
          <DoveDormireTabContent color={props.tabColor1} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: 'tab2',
        icon: 'tree',
        content: intl.formatMessage(messages.prenotazioni_esperienze),
        className: props.tabColor2,
      },
      render: () => (
        <TabPane attached={false}>
          <EsperienzeTabContent color={props.tabColor2} />
        </TabPane>
      ),
    },
    {
      menuItem: {
        key: 'tab3',
        icon: 'ticket',
        content: intl.formatMessage(messages.prenotazioni_myfe_card),
        className: props.tabColor3,
      },
      render: () => (
        <TabPane attached={false}>
          <MyFeCardTabContent color={props.tabColor3} />
        </TabPane>
      ),
    },
  ];
};

export default Tabs;

const messages = defineMessages({
  prenotazioni_dove_dormire: {
    id: 'prenotazioni_dove_dormire',
    defaultMessage: 'Dove dormire',
  },
  prenotazioni_esperienze: {
    id: 'prenotazioni_esperienze',
    defaultMessage: 'Esperienze',
  },
  prenotazioni_myfe_card: {
    id: 'prenotazioni_myfe_card',
    defaultMessage: 'My FE Card',
  },
});
